import { createReducer } from '@reduxjs/toolkit';

import getCarModelList from '../../thunks/general/getCarModelList';

const initialState = {
  loading: false,
  error: null,
  list: [],
  total: 0
};

const getCarModelListReducer = createReducer(initialState, {
  [getCarModelList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCarModelList.fulfilled]: (state, { payload: { data, total } }) => ({
    ...state,
    list: data.map(({ model }) => ({ label: model, value: model })),
    loading: false,
    total
  }),
  [getCarModelList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCarModelListReducer;
